// extracted by mini-css-extract-plugin
module.exports = {"main":"Product_main__1E04i","card":"Product_card__U8jDp","price":"Product_price__2MKa4","img-container":"Product_img-container__wxfU0","footer":"Product_footer__TWb-3"};